import React from "react";
import LoadingDots from "@/components/LoadingDots";

interface CountValueProps {
    value: number | string | null | undefined;
}

const CountValue: React.FC<CountValueProps> = ({ value }) => {
    if (value === undefined) return <LoadingDots />;

    return <>{value}</>;
};

export default CountValue;
